module.exports = __webpack_public_path__ + "assets/email-black.b4e50593.svg";